import React from "react";

import Searchbar from "../../utils/searchbar/Searchbar";
import SearchNews from "../../search/SearchNews";

class NewsSearch extends React.PureComponent {
	render() {
		return (
			<React.Fragment>
				<Searchbar
					placeholder={"Search news"}
					component={SearchNews}
					searchEndpoint={"search/news"}
					basePath={this.props.location.pathname + "/edit"}
					{...this.props}
					userType="admin"
				/>
			</React.Fragment>
		);
	}
}

export default NewsSearch;



// WEBPACK FOOTER //
// ./src/components/admin/news/NewsSearch.js